<template>
  <div ref="imageBackground" class="message-image message-image-admin">
    <img :src="message.file.url" alt="">
  </div>
</template>

<script>

export default {
  name: 'ChatImageAdmin',
  components: {},
  props: {
    message: {},
    imageHover: {},
    isImageLoading: {},
  },
  data() {
    return {};
  },
  computed: {
    componentClass() {
      return {
        'image-loading': this.isImageLoading,
        'image-media': this.message.media,
        'image-gift': this.message.gift,
        'image-blurred': this.message.media && this.message.media.is_blurred,
      };
    }
  },
  methods: {
    emitBuyMedia(message) {
      this.$emit('buyMedia', { media: message.media, message: message });
    },
  },
  watch: {},
  mounted() {
    $(this.$refs.imageBackground).magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      mainClass: 'mfp-img-mobile',
      image: {
        verticalFit: true
      }
    });
  }
};
</script>
